import { Input } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
  background-color: ${COLOR_OPTIONS.NEUTRAL_10};
  height: 32px;

  @media (max-width: 768px) {
    height: 40px;
    font-size: 16px;
    border-radius: 8px;
  }
`;
